import { render, staticRenderFns } from "./DownloadLoanListItem.vue?vue&type=template&id=064c66e6"
import script from "./DownloadLoanListItem.vue?vue&type=script&lang=js"
export * from "./DownloadLoanListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports